export const LEFT_MIN_WIDTH = 360
export const RIGHT_MIN_WIDTH = 900
export const CP_PANEL_INITIAL_WIDTH = 400

export const TM_CP_PANEL_COLLAPSED_CUSTOMERS_SET_LS_KEY = "cp_panel_collapsed_customers"
export const TM_CP_PANEL_WIDTH_LS_KEY = 'tm_cp_panel_width'


// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/constants.js